/** Ducati Laser — 제품·산업 디자인 공통 케이스 데이터 */

export const DUCATI_LASER_SLUG = 'ducati-laser'

export const DUCATI_LASER_SHEET_IMG = '/assets/img/design/ducati-laser-sheet.png'
export const DUCATI_LASER_COLLAGE_IMG = '/assets/img/design/ducati-laser-collage.png'
export const DUCATI_LASER_STUDIO_IMG = '/assets/img/design/ducati-laser-studio.png'

export const ducatiLaserPortfolioCard = {
    slug: DUCATI_LASER_SLUG,
    title: 'Ducati Laser',
    excerpt:
        '오토바이 프레임 모티브의 역동적 실루엣, 관절형 암·터치 UI를 갖춘 의료용 레이저 치료기입니다.',
    image: DUCATI_LASER_STUDIO_IMG,
    imageAlt: 'Ducati Laser 의료용 레이저 치료기 — 스튜디오 3D 렌더',
    year: '2023',
    tags: ['의료기기', '산업 디자인', 'CMF'],
}

const ducatiLaserShowcases = [
    {
        id: 'ducati-collage',
        kicker: 'Detail',
        title: '구조 & 조작부',
        tagline: '관절 암 · 핸드피스 · 냉각',
        image: DUCATI_LASER_COLLAGE_IMG,
        imageAlt:
            'Ducati Laser — 측면 전체, 크롬 관절 암·핸드피스, 후면 냉각·그립·전원 디테일 콜라주',
        description: [
            '좌측에서는 캐스터 베이스·백색 본체·상단 터치 패널·비상 정지 버튼이 있는 전체 실루엣을 확인할 수 있습니다. 우측 상단은 크롬 관절 암과 블루 LED 링이 있는 핸드피스 클로즈업입니다.',
            '우측 하단은 대형 냉각 그릴·후면 핸들·전원 패널을 담아 고출력 레이저 운용에 필요한 열·이동·전원 구조를 표현했습니다.',
        ],
        features: [
            {
                title: '다관절 암',
                text: '넓은 작업 범위와 정밀한 핸드피스 포지셔닝을 위한 7관절급 관절 구조를 전제했습니다.',
            },
            {
                title: '핸드피스 피드백',
                text: '선단 블루 LED 링으로 대기·가동 상태를 직관적으로 전달합니다.',
            },
            {
                title: '냉각 시스템',
                text: '후면 대형 퍼포레이션 그릴로 연속 운전 시 열 배출 구조를 시각화했습니다.',
            },
            {
                title: '이동·조작',
                text: '4륜 캐스터·후면 그립·상단 경사 터치스크린으로 클리닉 내 이동·설정을 지원합니다.',
            },
        ],
    },
    {
        id: 'ducati-studio',
        kicker: 'Studio',
        title: 'Ducati Laser',
        tagline: 'Laser therapy device',
        image: DUCATI_LASER_STUDIO_IMG,
        imageAlt: 'Ducati Laser 의료용 레이저 — 듀얼 유닛 스튜디오 렌더',
        description: [
            '다크 스튜디오 배경에서 두 대의 유닛을 배치해 프리미엄 의료기기 이미지를 강조했습니다. 화이트·실버 본체와 블랙 암·베이스의 대비로 전문 장비 톤을 유지합니다.',
            '오토바이 프레임에서 영감을 받은 날렵한 각과 수평 볼륨이 전통적인 박스형 의료기기와 차별화됩니다.',
        ],
        features: [
            {
                title: '역동적 실루엣',
                text: '오토바이 프레임 모티브의 날렵·역동적 외관으로 환자 경험을 긍정적으로 전달합니다.',
            },
            {
                title: '듀얼 컬러웨이',
                text: '라이트 그레이 본체·블랙 기능부·크롬 암으로 CMF 계층을 분명히 했습니다.',
            },
            {
                title: '안전 UI',
                text: '상단 터치스크린과 레드 비상 정지 버튼을 동일 시야에 배치했습니다.',
            },
            {
                title: '현장 이동성',
                text: '의료용 캐스터·후면 핸들로 진료실 간 이동 시나리오를 반영했습니다.',
            },
        ],
    },
]

const ducatiLaserProcessPhases = [
    {
        id: 'concept',
        title: '콘셉트 & 스토리',
        lede: '오토바이의 강렬하고 역동적인 스타일을 의료 레이저 치료기에 접목했습니다.',
        body: '환자에게 덜 위압적인, 긍정적인 인상을 주는 외관을 목표로 프레임·탱크 형상의 자동차 디자인 언어를 의료기기 볼륨에 번역했습니다.',
    },
    {
        id: 'form',
        title: '형태 & 인체공학',
        lede: '백색 매트 본체·다크 베이스·크롬 암으로 기능 구역을 분리했습니다.',
        body: '1128×593×1394(mm) 스케일에서 측면 환기 슬릿, 상단 조작면, 관절 암 도달 범위를 CAD 단계에서 검증했습니다. METAL·PLASTIC 재질 조합을 전제했습니다.',
    },
    {
        id: 'ux',
        title: '조작 & 임상 UX',
        lede: '경사 터치 디스플레이·비상 정지·핸드피스를 한 운영 루프로 연결했습니다.',
        body: '시술자는 상단에서 파라미터를 조정하고, 관절 암으로 정밀 위치를 잡은 뒤 핸드피스로 치료를 진행하는 동선을 전제했습니다.',
    },
    {
        id: 'viz',
        title: '시각화',
        lede: 'Rhino·KeyShot·Photoshop으로 시트·콜라주·스튜디오 렌더를 제작했습니다.',
        body: '제품 시트(스펙·카피), 3분할 디테일 콜라주, 듀얼 유닛 스튜디오 컷으로 마케팅·상세 페이지에 맞는 산출물 세트를 구성했습니다.',
    },
]

export const ducatiLaserDesignCase = {
    pageTitle: 'Ducati Laser 의료용 레이저',
    masthead: 'Ducati Laser',
    mastheadSub: 'Laser therapy device',
    showcaseSectionTitle: '제품 특징 · 상세',
    metaDescription:
        'Ducati Laser 의료용 레이저 치료기 — 오토바이 모티브 역동적 실루엣, 관절 암·터치 UI, 산업·제품 디자인 3D 렌더 사례입니다.',
    meta: {
        client: 'Ducati Laser',
        year: '2023',
        scope: '산업·제품 디자인 · Rhino · KeyShot · Photoshop',
        size: '1128 × 593 × 1394 (mm)',
        material: 'METAL, PLASTIC',
    },
    intro: {
        lead: '의료용 레이저 치료기의 콘셉트는 오토바이의 강렬하고 역동적인 스타일을 담아 환자에게 긍정적인 경험을 제공합니다.',
        left: '외관은 오토바이 프레임을 모티브로 날렵하고 역동적인 디자인으로 제작했습니다. 캐스터 이동·관절형 암·상단 터치 UI·비상 정지로 임상 환경을 고려했습니다.',
        right: '신선도·스마트 관리와 같은 소형 가전이 아닌, 클리닉 설비로서의 존재감과 정밀 조작성을 동시에 표현하는 산업·제품 통합 사례입니다.',
    },
    hero: {
        src: DUCATI_LASER_SHEET_IMG,
        alt: 'Ducati Laser 제품 시트 — Laser therapy device, 스펙·3D 렌더',
    },
    productShowcases: ducatiLaserShowcases,
    processPhases: ducatiLaserProcessPhases,
    deliverables: [
        '오토바이 모티브 콘셉트·실루엣 스케치 및 스토리보드',
        'Rhino 3D CAD·관절 암·본체 분할 데이터',
        'KeyShot 스튜디오·콜라주·시트 렌더',
        'CMF·터치 UI·비상 정지 배치 시안',
        '제품 스펙 시트(1128×593×1394 mm · METAL/PLASTIC · 2023)',
    ],
    outro: [
        '의료기기도 브랜드 스토리와 형태 언어로 환자·시술자 경험을 바꿀 수 있습니다.',
        'Ducati Laser는 산업 장비 스케일의 제품 디자인과 임상 UX를 함께 다룬 사례입니다.',
        '코담디자인은 의료·산업 장비의 형태·CMF·렌더 시각화를 지원합니다.',
    ],
    newsletterHeadline:
        '의료·산업 장비의 형태와 조작 경험을 설계하고 싶다면, 코담과 함께 범위를 정리해 보세요.',
}
